import React, { useEffect, useState } from 'react';
import { ShoppingBag, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface NavigationProps {
  cartCount: number;
  onOpenCart: () => void;
}
export function Navigation({
  cartCount,
  onOpenCart
}: NavigationProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'SHOP',
    href: '#shop'
  }, {
    name: 'DROPS',
    href: '#drops'
  }, {
    name: 'FIGHTERS',
    href: '#fighters'
  }, {
    name: 'ABOUT',
    href: '#about'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'glass-nav py-3' : 'bg-transparent py-5'}`} data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex justify-between items-center" data-id="element-150">
        {/* Logo */}
        <motion.a href="#" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} aria-label="Zehners Merch – Home" data-id="element-151">
          <img src="https://cdn.magicpatterns.com/uploads/igMiamPeru7PGzkV6cwrzL/logo_ohne-hintergrund-klein.png" alt="Zehners Merch Logo" className="h-12 md:h-14 w-auto object-contain" data-id="element-152" />
        </motion.a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-153">
          {navLinks.map((link, i) => <motion.a key={link.name} href={link.href} initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.1
        }} className="text-lg font-barlow font-bold tracking-[0.2em] transition-all duration-300 relative group" style={{
          color: '#888'
        }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(245,230,20,0.85)'} onMouseLeave={e => e.currentTarget.style.color = '#888'} data-id="element-154">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-px transition-all duration-300 group-hover:w-full" style={{
            background: 'rgba(245,230,20,0.5)',
            boxShadow: '0 0 8px rgba(245,230,20,0.4)'
          }} data-id="element-155" />
            </motion.a>)}
        </div>

        {/* Actions */}
        <div className="flex items-center space-x-6" data-id="element-156">
          <motion.button initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} onClick={onOpenCart} className="relative group p-2" aria-label="Open cart" data-id="element-157">
            <ShoppingBag className="w-6 h-6 transition-all duration-300" style={{
            color: '#888'
          }} data-id="element-158" />
            {cartCount > 0 && <span className="absolute -top-1 -right-1 text-black text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full" style={{
            background: 'rgba(245,230,20,0.9)',
            boxShadow: '0 0 10px rgba(245,230,20,0.4)'
          }} data-id="element-159">
                {cartCount}
              </span>}
          </motion.button>

          <button className="md:hidden" style={{
          color: '#e0e0e0'
        }} onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-160">
            <Menu className="w-8 h-8" data-id="element-161" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-162">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} className="fixed inset-0 bg-fight-black z-50 flex flex-col overflow-y-auto" data-id="element-163">
            {/* Close button */}
            <div className="flex justify-between items-center px-6 pt-6 pb-4 flex-shrink-0" data-id="element-164">
              <img src="https://cdn.magicpatterns.com/uploads/igMiamPeru7PGzkV6cwrzL/logo_ohne-hintergrund-klein.png" alt="Zehners Merch" className="h-12 w-auto" data-id="element-165" />
              <button className="text-white p-2" onClick={() => setIsMobileMenuOpen(false)} aria-label="Close menu" data-id="element-166">
                <X className="w-8 h-8" data-id="element-167" />
              </button>
            </div>

            {/* Links */}
            <div className="flex flex-col items-center justify-center flex-1 space-y-6 py-8 px-6" data-id="element-168">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-5xl font-bebas text-white hover:text-fight-yellow transition-colors w-full text-center border-b border-white/5 pb-6 last:border-0" data-id="element-169">
                  {link.name}
                </a>)}
            </div>

            {/* Bottom CTA */}
            <div className="px-6 pb-8 flex-shrink-0" data-id="element-170">
              <button onClick={() => {
            setIsMobileMenuOpen(false);
          }} className="w-full bg-fight-red text-white py-4 font-bebas text-2xl tracking-wider" data-id="element-171">
                SHOP NOW
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}